<template>
    <div class="container-fluid mt-2" style="font-family:'Courier New'">
      <div class="text-center">
        <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="40"/></span>
        <span v-else><img src="@/assets/images/logo.png" height="40"/></span><br>
        <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
        <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
        <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br><br>
        <span v-if="userData.slogan" style="color:black;font-size:13px;font-style:italic">Slogan: {{ userData.slogan }}</span><br>
        <span style="color: black;font-size:13px" class="text-decoration-underline"><b> PAYMENT`s LEDGER</b></span><br>
        <span style="color:black;font-size:13px"> Visit ID : {{ this.visitid }}</span><br>
       
    </div>
      <div v-for="item in patients" :key="item.id" class="text-center">
      <h6><span> Full Name: </span><b class=" h7">{{ item.name }} </b></h6>
      <h6><span> Patient ID: </span> <b class=" h7">{{ item.patient_id }} </b></h6>
      <h6><span> Gender: </span> <span class=" h7">{{ item.gender }} </span></h6>
      <h6><span> Telephone: </span> <span class=" h7">0{{ item.telephone }} </span></h6>
      <h6><span> Address: </span> <span class=" h7">{{ item.address }} </span></h6>
      <h6><span> NIN / Passport No: </span> <span class=" h7">{{ item.nin }} </span></h6>
      </div>
      <!-- <div v-if="userData.settings.print_trans == '1'" > -->
        <div v-if="userData && userData.settings && userData.settings.print_trans == '1'">
    <span v-if="services.length">
    <h5 >Services</h5>
      <table class="table table-sm mt-n2" style="color: black;" density="compact">
      <thead><tr><th>Category</th><th>Service Name</th><th>Price</th></tr></thead>
      <tbody>
        <tr v-for="item in services" :key="item.id">
            <td>{{ item.service_category.name }} </td>
            <td>{{ item.service_name.name }}</td>
            <td>{{ item.service_price }}</td>
        </tr>
      </tbody>
      </table>
      </span>
      <span v-if="prescriptions.length">
          <h5 >Presciptions</h5>
            <table class="table table-sm mt-n2" style="color: black;" density="compact">
            <thead><tr><th>Medicine</th><th>Quantity</th><th>Price</th></tr></thead>
            <tbody>
                <tr v-for="item in prescriptions" :key="item.id">
                <td>{{ item.medicine.name }} </td>
                <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
                <td>{{ item.totalprice }}</td>
                </tr>
            </tbody>
            </table>
        </span>
        <span v-if="consumables.length">
        <h5 >Consumables</h5>
          <table class="table table-sm mt-n2" style="color: black;" density="compact">
          <thead><tr><th>Consumable</th><th>Quantity</th><th>Price</th></tr></thead>
          <tbody>
              <tr v-for="item in consumables" :key="item.id">
              <td>{{ item.consumbale.name }} </td>
              <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
              <td>{{ item.totalprice }}</td>
              </tr>
          </tbody>
          </table>
        </span>
      <span v-if="payments.length">
    <h5 >Payments</h5>
      <table class="table table-sm mt-n2" style="color: black;" density="compact">
      <thead><tr><th>Pay Date</th><th>Amount Paid Time</th><th>Discount</th><th>Payment Type</th></tr></thead>
      <tbody>
        <tr v-for="item in payments" :key="item.id">
            <td>{{ item.pay_date }}</td>
            <td>{{ commas(item.amount_paid) }}</td>
            <td>{{ commas(item.amount_discount) }}</td>
            <td>
              <span v-if="item.payment_type==1">Cash</span>
              <span v-else>Account</span>
            </td>
        </tr>
      </tbody>
      </table>
      </span>
      </div>
<!-- no detailed receipt -->
      <div v-else>
        <span v-if="services.length">
    <h5 >Services</h5>
      <table class="table table-sm mt-n2" style="color: black;" density="compact">
        <thead><tr><th>Category</th><th>Service Name</th></tr></thead>

      <tbody>
        <tr v-for="item in services" :key="item.id">
                          <td>{{ item.service_category.name }} </td>
                          <td>{{ item.service_name.name }}</td>
                         
        </tr>
      </tbody>
      </table>
      </span>
      <span v-if="prescriptions.length">
          <h5 >Presciptions</h5>
            <table class="table table-sm mt-n2" style="color: black;" density="compact">
              <thead><tr><th>Medicine</th><th>Quantity</th></tr></thead>

            <tbody>
              <tr v-for="item in prescriptions" :key="item.id">
                          <td>{{ item.medicine.name }} </td>
                          <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
              </tr>
            </tbody>
            </table>
        </span>
        <span v-if="consumables.length">
        <h5 >Consumables</h5>
          <table class="table table-sm mt-n2" style="color: black;" density="compact">
       
          <tbody>
            <tr v-for="item in consumables" :key="item.id">
                        <td>{{ item.consumbale.name }} </td>
                        <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
                      
            </tr>
          </tbody>
          </table>
        </span>
        <h5 >Total Amount</h5>
        <table class="table table-sm mt-n2" style="color: black;" density="compact">
          <tr>
            <td> <b>   {{ commas (totalAmountPrice) }} </b></td>
          </tr>
        </table>
      <span v-if="payments.length">
    <h5 >Payments</h5>
      <table class="table table-sm mt-n2" style="color: black;" density="compact">
      <thead><tr><th>Pay Date</th><th>Amount Paid Time</th><th>Discount</th><th>Payment Type</th></tr></thead>
      <tbody>
        <tr v-for="item in payments" :key="item.id">
            <td>{{ item.pay_date }}</td>
            <td>{{ commas(item.amount_paid) }}</td>
            <td>{{ commas(item.amount_discount) }}</td>
            <td>
              <span v-if="item.payment_type==1">Cash</span>
              <span v-else>Account</span>
            </td>
        </tr>
      </tbody>
      </table>
      </span>
    </div>
      <div class="mt-2 text-center">
        <span style="color: black;font-size:14px"><b> AMOUNT PAID : {{commas(amount_paid)}}</b></span><br>
        <span style="color: black;font-size:14px"><b> DISCOUNT : {{commas(amount_discount)}}</b></span><br>
        <span style="color: black;font-size:14px"><b> PENDING BALANCE : {{commas(balance)}}</b></span><br>
        <p style="color:black;font-size:13px">Printed by : {{ userData.username }}
        <br> On : {{ new Date().toLocaleString() }}
        <br>Thanks for Supporting Us. <br> Printed Via Afrimed Software
        <br> www.afrimedsolutions.com </p>
    </div>
  </div>
    
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      patients:[],
      payments:[],
      services:[],
      patientid:'',
      visitid:'',
      consumables:[],
      prescriptions:[],
      amount_paid:0,
      amount_discount:0,
      balance:0,
    }
  },
  created() {
    this.fetchInfo();
  },
 
  // computed: {
  // totalServicePrice() {
  //   return this.services.reduce((total, service) => total + service.service_price, 0);
  // },
  // totalPresciptionsPrice() {
  //   return this.prescriptions.reduce((total, prescription) => total + prescription.totalprice, 0);
  // },
  // totalComsumablePrice() {
  //   return this.consumables.reduce((total, consumable) => total + consumable.totalprice, 0);
  // },
  // totalAmountPrice(){
  //   return this.totalComsumablePrice + this.totalPresciptionsPrice + this.totalServicePrice
  // },

  // },
  computed: {
  totalServicePrice() {
    return this.services.reduce((total, service) => total + Number(service.service_price || 0), 0);
  },
  totalPresciptionsPrice() {
    return this.prescriptions.reduce((total, prescription) => total + Number(prescription.totalprice || 0), 0);
  },
  totalComsumablePrice() {
    return this.consumables.reduce((total, consumable) => total + Number(consumable.totalprice || 0), 0);
  },
  totalAmountPrice() {
    return this.totalComsumablePrice + this.totalPresciptionsPrice + this.totalServicePrice;
  }
},
  methods: {
    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    async fetchInfo(){
      this.id=this.$route.query.id;
      let url = `/legderinfo/${this.id}`;
      await axios.get(url).then((response) => {
        this.patientid = response.data.visits[0].patient.patient_id;
        this.visitid = response.data.visits[0].visit_id;
        this.showpatient();
        
      });
    },
    async showpatient(){
      let url = `/patientprofile/${this.patientid}`;
      await axios.get(url).then((response) => {
        this.patients = response.data.patients;
        this.showpayments();
        this.showservices();
        this.showtprescriptions();
        this.showtconsumables();
        this.showbalances();

      });
    },
    async showservices(){
      let url = `/profileservices/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.services = response.data.visits;
      });
    },
    async showtprescriptions(){
        let url = `/profileprescription/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.prescriptions = response.data.prescriptions;
        });
      },
      async showtconsumables(){
        let url = `/profileconsumables/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.consumables = response.data.consumables;
        });
      },
    async showpayments(){
      let url = `/legdgerpayments/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.payments = response.data.payments;
      });
    },
    async calculateTotalServiceAmount() {
      // Initialize total amount variable
      let totalAmount = 0;
      
      // Loop through each service item and sum up the service prices
      this.services.forEach(item => {
        totalAmount += item.service_price;
      });
      
      // Return the total amount
      return totalAmount;
    },
    async showbalances(){
      let url = `/invoicepayments/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.amount_paid = response.data.payments[0].paid;
        this.balance = response.data.payments[0].balance;
        this.amount_discount = response.data.payments[0].discount;

        setTimeout(() => { window.print(); window.onafterprint=this.$router.go(-1); }, 2000);
      });
    },
  },
  };
</script>